import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/usuario`;


export default class UsuarioService{
	static consultarUsuarios(
		tipoPessoa = "",
		email = "",
		cpf = "",
		cnpj = "",
		pagina = 0,
		usuariosPorPagina = 15,
	) {
		return axios.get(
			URL_BASE + "/consultar"
            + "?tipoPessoa=" + tipoPessoa
			+ "&email=" + email
			+ "&cpf=" + cpf
			+ "&cnpj=" + cnpj
			+ "&pagina=" + pagina
			+ "&usuariosPorPagina=" + usuariosPorPagina,
		);
	}

	static consultarUsuarioPorId(
		id = 0,
	) {
		return axios.get(
			URL_BASE + "/consultar/" + id,
		);
	}
}



// WEBPACK FOOTER //
// ./src/service/UsuarioService.js